/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SetupAttemptSchema
 */
export interface SetupAttemptSchema {
    /**
     * 
     * @type {number}
     * @memberof SetupAttemptSchema
     */
    id: number;
    /**
     * 
     * @type {Date}
     * @memberof SetupAttemptSchema
     */
    created: Date;
    /**
     * 
     * @type {Date}
     * @memberof SetupAttemptSchema
     */
    updated: Date;
    /**
     * 
     * @type {string}
     * @memberof SetupAttemptSchema
     */
    externalId: string;
    /**
     * 
     * @type {boolean}
     * @memberof SetupAttemptSchema
     */
    complete: boolean;
    /**
     * 
     * @type {string}
     * @memberof SetupAttemptSchema
     */
    roleArn?: string;
    /**
     * 
     * @type {string}
     * @memberof SetupAttemptSchema
     */
    link: string;
}

/**
 * Check if a given object implements the SetupAttemptSchema interface.
 */
export function instanceOfSetupAttemptSchema(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "created" in value;
    isInstance = isInstance && "updated" in value;
    isInstance = isInstance && "externalId" in value;
    isInstance = isInstance && "complete" in value;
    isInstance = isInstance && "link" in value;

    return isInstance;
}

export function SetupAttemptSchemaFromJSON(json: any): SetupAttemptSchema {
    return SetupAttemptSchemaFromJSONTyped(json, false);
}

export function SetupAttemptSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): SetupAttemptSchema {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'created': (new Date(json['created'])),
        'updated': (new Date(json['updated'])),
        'externalId': json['external_id'],
        'complete': json['complete'],
        'roleArn': !exists(json, 'role_arn') ? undefined : json['role_arn'],
        'link': json['link'],
    };
}

export function SetupAttemptSchemaToJSON(value?: SetupAttemptSchema | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'created': (value.created.toISOString()),
        'updated': (value.updated.toISOString()),
        'external_id': value.externalId,
        'complete': value.complete,
        'role_arn': value.roleArn,
        'link': value.link,
    };
}

